import cx from 'classnames';
import PropTypes from 'prop-types';

import CustomLink from 'src/components/CustomLink';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const UnauthenticatedPageFooterTextLink = ({ className, text, link, from }) => {
  const styles = useStyles();

  return (
    <CustomTypography
      className={cx(styles.root, className)}
      variant={TYPOGRAPHY_VARIANT.regular16}
    >
      {text && <span className={styles.text}>{text}</span>}
      {link && (
        <CustomLink
          to={link.to}
          data-testid={link.testId}
          state={{ from }}
          invertUnderline
        >
          {link.text}
        </CustomLink>
      )}
    </CustomTypography>
  );
};

UnauthenticatedPageFooterTextLink.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.shape({
    to: PropTypes.string,
    testId: PropTypes.string,
    text: PropTypes.string,
  }),
  from: PropTypes.string,
};

UnauthenticatedPageFooterTextLink.defaultProps = {
  className: null,
  text: null,
  link: null,
  from: null,
};
